import { render, staticRenderFns } from "./ModalSuporteEditarHospital.vue?vue&type=template&id=72c775f4&scoped=true"
import script from "./ModalSuporteEditarHospital.vue?vue&type=script&lang=ts"
export * from "./ModalSuporteEditarHospital.vue?vue&type=script&lang=ts"
import style0 from "./ModalSuporteEditarHospital.vue?vue&type=style&index=0&id=72c775f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72c775f4",
  null
  
)

export default component.exports